"use client";
// El enlace al otro idioma conserva la página en la que estás (antes siempre mandaba a la portada).
import { usePathname } from "next/navigation";
import { Enlace } from "@/components/Enlace";

export const enOtroIdioma = (ruta: string | null, otro: string) => {
  const r = ruta ?? "/";
  return /^\/(es|en)(?=\/|$)/.test(r) ? r.replace(/^\/(es|en)/, `/${otro}`) : `/${otro}`;
};

export function useRutaOtroIdioma(otro: string) {
  return enOtroIdioma(usePathname(), otro);
}

export function CambioIdioma({ otro, texto, className, onClick }: { otro: string; texto: string; className?: string; onClick?: () => void }) {
  const href = useRutaOtroIdioma(otro);
  return <Enlace href={href} className={className} hrefLang={otro} lang={otro} onClick={onClick}>{texto}</Enlace>;
}
